export default __webpack_public_path__ + "static/media/healthgenom_broken_heart.f7d06c22.svg";